// extracted by mini-css-extract-plugin
export default {"container":"iXagb9np","skeleton":"R0_segNB"};